import React, { ChangeEvent } from 'react';
import { useIntl } from 'react-intl';

import { Rule } from 'antd/lib/form';
import { removeMaskFromEvent } from '@/utils/mask/removeMask';
import { maskFieldValidator } from '@/utils/mask';

import FloatingFormItem from '../FloatingFormItem';
import InputText from '../InputText';

type Props = {
  fieldName?: string;
  label?: string;
  requiredRuleTextId?: string;
  lengthRuleTextId?: string;
  required?: boolean;
  initialValue?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

const RgFormField: React.FC<Props> = ({
  label = 'RG',
  onChange,
  fieldName = 'rg',
  requiredRuleTextId = 'commons.form.errors.requiredRg',
  lengthRuleTextId = 'commons.form.errors.invalidRg',
  initialValue,
  required,
}) => {
  const intl = useIntl();

  const rules: Rule[] = [
    {
      min: 7,
      max: 13,
      validator: maskFieldValidator,
      message: intl.formatMessage({ id: lengthRuleTextId }),
    },
  ];

  if (required) {
    rules.push({
      required: true,
      message: intl.formatMessage({ id: requiredRuleTextId }),
    });
  }

  return (
    <FloatingFormItem
      label={label + ' (apenas números)'}
      name={fieldName}
      initialValue={initialValue}
      getValueFromEvent={(event) => {
        if (onChange) {
          onChange(event);
        }
        return removeMaskFromEvent(event);
      }}
      rules={rules}
    >
      <InputText onlyNumber maxLength={13} />
    </FloatingFormItem>
  );
};

export default RgFormField;
